module.exports = {
      id: "personalise-usage",
      viewBox: "0 0 14.128 12.555",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#personalise",
      toString: function () {
        return this.url;
      }
    }